<template>
  <listCategoriesMarketpaceComponent />
</template>

<script>
import listCategoriesMarketpaceComponent from "@/views/categories_marketplace/pages/list_categories_marketplace/components/list_categories_marketplace_component.vue";
export default {
  name: "categories",
  components: {
    listCategoriesMarketpaceComponent,
  },
};
</script>

<style lang="css" scoped>
</style>
